import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './self-service.component.scss';
var SelfService = /** @class */ (function (_super) {
    tslib_1.__extends(SelfService, _super);
    function SelfService(element) {
        return _super.call(this, element) || this;
    }
    SelfService.prototype.init = function () { };
    SelfService.prototype.bindEvents = function () { };
    return SelfService;
}(Base));
export { SelfService };



//////////////////
// WEBPACK FOOTER
// ./components/self-service/self-service.component.ts
// module id = 493
// module chunks = 0